/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkTimeAllocationParam } from './WorkTimeAllocationParam';
import {
    WorkTimeAllocationParamFromJSON,
    WorkTimeAllocationParamFromJSONTyped,
    WorkTimeAllocationParamToJSON,
    WorkTimeAllocationParamToJSONTyped,
} from './WorkTimeAllocationParam';

/**
 * 
 * @export
 * @interface SaveCounselorWorkTimeRequest
 */
export interface SaveCounselorWorkTimeRequest {
    /**
     * 
     * @type {number}
     * @memberof SaveCounselorWorkTimeRequest
     */
    weeklyHours: number;
    /**
     * 
     * @type {Array<WorkTimeAllocationParam>}
     * @memberof SaveCounselorWorkTimeRequest
     */
    allocations: Array<WorkTimeAllocationParam>;
}

/**
 * Check if a given object implements the SaveCounselorWorkTimeRequest interface.
 */
export function instanceOfSaveCounselorWorkTimeRequest(value: object): value is SaveCounselorWorkTimeRequest {
    if (!('weeklyHours' in value) || value['weeklyHours'] === undefined) return false;
    if (!('allocations' in value) || value['allocations'] === undefined) return false;
    return true;
}

export function SaveCounselorWorkTimeRequestFromJSON(json: any): SaveCounselorWorkTimeRequest {
    return SaveCounselorWorkTimeRequestFromJSONTyped(json, false);
}

export function SaveCounselorWorkTimeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveCounselorWorkTimeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'weeklyHours': json['weeklyHours'],
        'allocations': ((json['allocations'] as Array<any>).map(WorkTimeAllocationParamFromJSON)),
    };
}

export function SaveCounselorWorkTimeRequestToJSON(json: any): SaveCounselorWorkTimeRequest {
    return SaveCounselorWorkTimeRequestToJSONTyped(json, false);
}

export function SaveCounselorWorkTimeRequestToJSONTyped(value?: SaveCounselorWorkTimeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'weeklyHours': value['weeklyHours'],
        'allocations': ((value['allocations'] as Array<any>).map(WorkTimeAllocationParamToJSON)),
    };
}

